module.exports = __webpack_public_path__ + "img/shm_logo_Login.c559f575.svg";